import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-icons',
    templateUrl: './icons.component.html',
    styleUrls: ['./icons.component.scss'],
    standalone: false
})
export class IconsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
